import ErrorPage from '@/components/errors/ErrorPage';

export default function Forbidden() {
  return (
    <ErrorPage
      code="403"
      emoji="🔒"
      title="Access denied"
      description="You are authenticated, but this action or page is not allowed for your current permissions."
      details="If this seems wrong, check your token, role, or server auth configuration."
    />
  );
}
